import { useState } from 'react';
import ChartLibraryModal from '../../../components/feature/ChartLibraryModal';

export default function DataVisualization() {
  const [isChartLibraryOpen, setIsChartLibraryOpen] = useState(false);
  const visualizations = [
    {
      title: 'Interactive Dashboards',
      description: 'Drag-and-drop dashboard builder with 50+ chart types',
      image: 'https://public.readdy.ai/ai/img_res/14eb4fec77146e53c509a6159bea4f6c.jpg'
    },
    {
      title: 'Custom Reports',
      description: 'Generate branded reports with automated scheduling',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20report%20document%20layout%20with%20charts%20and%20graphs%20on%20dark%20background%2C%20clean%20typography%2C%20data%20tables%2C%20infographics%2C%20corporate%20design%2C%20dark%20theme%20with%20teal%20accents%2C%20modern%20minimalist%20style%2C%20executive%20summary%20format%2C%20high%20quality%20print-ready%20design&width=600&height=400&seq=viz-report-dark-001&orientation=landscape'
    },
    {
      title: 'Predictive Models',
      description: 'AI-driven forecasting with confidence intervals',
      image: 'https://readdy.ai/api/search-image?query=Futuristic%20predictive%20analytics%20visualization%20with%20AI%20neural%20network%20patterns%20on%20dark%20background%2C%20forecasting%20graphs%20showing%20future%20trends%2C%20machine%20learning%20algorithms%2C%20glowing%20teal%20and%20cyan%20data%20streams%2C%20holographic%20interface%20elements%2C%20advanced%20technology%20concept%2C%20cinematic%20lighting&width=600&height=400&seq=viz-predict-dark-001&orientation=landscape'
    }
  ];

  return (
    <>
      <section id="visualization" className="py-24 bg-gray-900">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-500/20 rounded-full mb-6 border border-teal-500/30">
              <i className="ri-pie-chart-line text-teal-400"></i>
              <span className="text-sm font-semibold text-teal-400">VISUALIZATION</span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              Beautiful Data Storytelling
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              Transform complex data into compelling visual narratives that drive action and inspire confidence.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {visualizations.map((viz, index) => (
              <div 
                key={index}
                className="group cursor-pointer"
              >
                <div className="aspect-[3/2] rounded-2xl overflow-hidden mb-6 shadow-lg group-hover:shadow-2xl group-hover:shadow-teal-500/20 transition-shadow border border-gray-800">
                  <img 
                    src={viz.image}
                    alt={viz.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <h3 className="text-2xl font-bold text-white mb-3">{viz.title}</h3>
                <p className="text-gray-400">{viz.description}</p>
              </div>
            ))}
          </div>

          <div className="text-center">
            <button 
              onClick={() => setIsChartLibraryOpen(true)}
              className="px-8 py-4 bg-teal-500 text-gray-900 rounded-lg font-semibold hover:bg-teal-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              Explore Chart Library
            </button>
          </div>
        </div>
      </section>

      <ChartLibraryModal 
        isOpen={isChartLibraryOpen} 
        onClose={() => setIsChartLibraryOpen(false)}
      />
    </>
  );
}